/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCouponShowResponse } from '../../models/discount-coupon-show-response';

export interface DeleteDiscountCouponRemove$Params {
  value: string;
}

export function deleteDiscountCouponRemove(http: HttpClient, rootUrl: string, params: DeleteDiscountCouponRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCouponShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteDiscountCouponRemove.PATH, 'delete');
  if (params) {
    rb.path('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCouponShowResponse>;
    })
  );
}

deleteDiscountCouponRemove.PATH = '/v1/discount-coupon/{value}';
